export default "__VITE_ASSET__39bb5f3a__"